import React, {useContext, useState} from 'react';
import {Col, Form, FormGroup, Label, Row} from "reactstrap";
import {Btn} from "../../../../AbstractElements";
import Loader from "../../../../Layout/Loader";
import {useForm} from "react-hook-form";
import axios from "../../../../Config/axios";
import {toast} from "react-toastify";
import {getSecureAuthenticationRoute} from "../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../_helper/Authorization";
import {UpdatePasswordFormProps, UpdatePasswordFormValues} from "../Types/UserTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

const UpdatePasswordForm = ({userID}: UpdatePasswordFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [togglePassword, setTogglePassword] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        handleSubmit,
        register,
        setError,
        formState: {errors},
    } = useForm<UpdatePasswordFormValues>();

    const onSubmit = async (data: UpdatePasswordFormValues) => {
        if (!userID) return;
        try {
            setLoaderVisibility(true);
            axios.put(`${getSecureAuthenticationRoute('change-password')}/${userID}`, data)
                .then(() => {
                    toast.success(`Password Updated`, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000,
                    });
                    setLoaderVisibility(false)
                }).catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false)
            });
        } catch (exception: any) {
            errorHandler(exception, setError);
            setLoaderVisibility(false)
        }
    };

    return (
        <div>
            <Loader visibility={loaderVisibility}/>
            <Row className={'justify-content-center'}>
                <Col md={6}>
                    <Form onSubmit={handleSubmit(onSubmit)}
                          className='theme-form login-form'>
                        <FormGroup className='position-relative'>
                            <Label className='col-form-label m-0'>Current Password</Label>
                            <div className='position-relative'>
                                <input className='form-control' type={togglePassword ? 'text' : 'password'}
                                       {...register('current_password', {required: true})}
                                       placeholder='*********'/>
                            </div>
                            <span
                                className='d-block invalid-feedback'>{errors.current_password && (errors.current_password.message ? errors.current_password.message : 'Please provide a valid password')}</span>
                        </FormGroup>
                        <FormGroup className='position-relative'>
                            <Label className='col-form-label m-0'>Password</Label>
                            <div className='position-relative'>
                                <input className='form-control' type={togglePassword ? 'text' : 'password'}
                                       {...register('password', {required: true})}
                                       placeholder='*********'/>
                                <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                                    <span className={togglePassword ? '' : 'show'}></span>
                                </div>
                            </div>
                            <span
                                className='d-block invalid-feedback'>{errors.password && (errors.password.message ? errors.password.message : 'Please provide a valid password')}</span>
                        </FormGroup>
                        {togglePassword ? null : <FormGroup className='position-relative'>
                            <Label className='col-form-label m-0'>Confirm Password</Label>
                            <div className='position-relative'>
                                <input className='form-control' type={togglePassword ? 'text' : 'password'}
                                       {...register('password_confirmation', {required: true})}
                                       placeholder='*********'/>
                            </div>
                            <span
                                className='d-block invalid-feedback'>{errors.password_confirmation && (errors.password_confirmation.message ? errors.password_confirmation.message : 'Please provide a valid password')}</span>
                        </FormGroup>}
                        <Btn attrBtn={{
                            className: 'd-block w-100 mt-4',
                            color: 'primary',
                            type: 'submit',
                        }}>Update</Btn>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

export default UpdatePasswordForm;
